import * as fromPayroll from './payroll.reducers';
import * as fromPayrollExtra from './payroll.extra.reducers';
import * as fromPayrollRule from './payroll.rule.reducers';
import * as fromPayrollUI from './payroll.ui.reducers';
import { Action, combineReducers } from '@ngrx/store';
import {
  PayrollState,
  PayrollUIState,
  PayrollExtraState,
  PayrollRuleState,
} from '../payroll.types';

export interface RouteState {
  apiRule: PayrollRuleState;
  apiExtra: PayrollExtraState;
  api: PayrollState;
  ui: PayrollUIState;
}
export interface State {
  payroll: RouteState;
}

export function reducers(
  state: RouteState | undefined,
  action: Action
): RouteState {
  return combineReducers({
    apiRule: fromPayrollRule.reducer,
    apiExtra: fromPayrollExtra.reducer,
    api: fromPayroll.reducer,
    ui: fromPayrollUI.reducer,
  })(state, action);
}

export { fromPayroll, fromPayrollExtra, fromPayrollRule };
